
import Vue from "vue";
import Component from "vue-class-component";
import SectionLayout from "../SectionLayout.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    SectionLayout
  }
})
export default class HomeFooter extends Vue {
  @Prop({ required: true, default: "" }) image!: string;

  get years() {
    return [2017, new Date().getFullYear()].join(" - ");
  }

  get isMobile() {
    // @ts-ignore
    return this.$vuetify.breakpoint.smAndDown;
  }

  get footerStyle() {
    return {
      backgroundImage: `url(${require('@/assets/images/footer-background.png')})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: '646px'
    }
  }

  mounted() {}
}
